// בינה-3 (07 §1).
import { z } from 'zod';
import { Row, Ts, Usage } from './common.ts';
import { OutputColumn, SpreadQuery } from './spreads.ts';

export const Viz = z.object({
  kind: z.enum(['table', 'line', 'bar', 'area', 'pie']),
  stacked: z.boolean().optional(),
  x: z.string().optional(),
  series: z.string().optional(),
});
export type Viz = z.infer<typeof Viz>;

export const AiQueryAnswer = z.object({
  kind: z.literal('answer'),
  form: SpreadQuery,
  columns: z.array(OutputColumn),
  rows: z.array(Row),
  asOf: Ts.nullable(),
  degraded: z.boolean(),
  truncated: z.boolean(),
  viz: Viz,
  summary: z.string().nullable(),
  definitionsUsed: z.array(z.object({ nameHe: z.string(), textHe: z.string() })),
  usage: Usage,
});

export const AiQueryValueNotFound = z.object({
  kind: z.literal('value_not_found'),
  missing: z.array(z.string()),
  suggestions: z.array(
    z.object({
      word: z.string(),
      near: z.array(z.object({ column: z.string(), value: z.string(), label: z.string().nullable() })),
    }),
  ),
  usage: Usage,
});

export const AiQueryUnsupported = z.object({
  kind: z.literal('unsupported'),
  reason: z.string(),
  unknown: z.array(z.string()),
  usage: Usage,
});

export const AiQueryUnavailable = z.object({ kind: z.literal('unavailable'), reason: z.string() });

export const AiQueryResult = z.discriminatedUnion('kind', [AiQueryAnswer, AiQueryValueNotFound, AiQueryUnsupported, AiQueryUnavailable]);
export type AiQueryResult = z.infer<typeof AiQueryResult>;

/** סיכום דטרמיניסטי על כל השורות (07). הבעלים מעדין. */
export const Digest = z.record(z.string(), z.unknown());
export type Digest = z.infer<typeof Digest>;

export const AiAnalyzeResult = z.object({
  text: z.string().nullable(),
  blocked: z.boolean(),
  digest: Digest,
  usage: Usage,
});
export type AiAnalyzeResult = z.infer<typeof AiAnalyzeResult>;

/** מה שהמודל מחזיר ב-ai.query (סכימת הפלט המובנה). */
export const AiModelOutput = z.object({
  form: SpreadQuery,
  notFound: z.array(z.string()).optional(),
  unknown: z.array(z.string()).optional(),
  viz: Viz.optional(),
});
export type AiModelOutput = z.infer<typeof AiModelOutput>;
